import Hero from "@/components/home/Hero";
import Stats from "@/components/home/Stats";
import About from "@/components/home/About";
import Services from "@/components/home/Services";
import ProgramsPreview from "@/components/home/ProgramsPreview";
import ManasikPreview from "@/components/home/ManasikPreview";
import GuidesPreview from "@/components/home/GuidesPreview";
import JourneyProcess from "@/components/home/JourneyProcess";
import WhyUs from "@/components/home/WhyUs";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import GalleryPreview from "@/components/home/GalleryPreview";
import ArticlesPreview from "@/components/home/ArticlesPreview";
import FAQSection from "@/components/home/FAQSection";
import FinalCTA from "@/components/home/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Stats />
      <About />
      <Services />
      <ProgramsPreview />
      <ManasikPreview />
      <GuidesPreview />
      <JourneyProcess />
      <WhyUs />
      <TestimonialsSection />
      <GalleryPreview />
      <ArticlesPreview />
      <FAQSection />
      <FinalCTA />
    </div>
  );
}
